import React from 'react';

import moment from 'moment-timezone';

import Estatus from '../../componentes/Estatus';
import ReportePersonal from '../../contenedores/ReportePersonal';
import { capitalizar } from '../../utilidades/functions';
import { REPORTE_CHECK_INDIVIDUAL } from '../../configuraciones/endpoints';

const cabeceros = [
  { label: 'Empleado', key: 'NombreCompleto' },
  { label: 'Empresa', transform: ({ Empresa }) => Empresa?.Nombre },
  { label: 'Sucursal', transform: ({ Sucursal }) => Sucursal?.Nombre },
  { label: 'Departamento', transform: ({ Departamento }) => Departamento?.Nombre },
  { label: 'Puesto', transform: ({ Puesto }) => Puesto?.Nombre },
];

const cabecerosDrawer = [
  { label: 'Fecha', transform: ({ FechaCheck }) => FechaCheck && capitalizar(moment(FechaCheck).format('DD MMMM YYYY')) },
  { label: 'Tipo Check', transform: ({ Movimiento }) => Movimiento ? Movimiento : null },
  { label: 'Check', transform: ({ HoraCheck }) => HoraCheck ? HoraCheck : null },
  { label: 'Horario', transform: ({ HoraHorario }) => HoraHorario ? HoraHorario : null },
  { label: 'Evaluación', transform: ({ Evaluacion }) => Evaluacion ? Evaluacion.Nombre : null },
  { label: 'Estatus', transform: ({ Estatus: estatusRegistro }) => estatusRegistro ? <Estatus Cadena={estatusRegistro.Nombre} Habilitado={false} /> : null },
]

const CheckIndividual = ({ history, location }) => {

  return (
    <ReportePersonal
      history={history}
      location={location}
      cabeceros={cabeceros}
      titulo="Reporte de checks individual"
      apiKey={REPORTE_CHECK_INDIVIDUAL}
      cabecerosDrawer={cabecerosDrawer}
      apiKeyDrawer={REPORTE_CHECK_INDIVIDUAL}
      tituloReporte="Reporte de checks individual"
    />
  );
};

export default CheckIndividual;
